import { communityPosts } from "@/mocks/gossip";

const toneBg = ["bg-primary-500", "bg-accent-500", "bg-secondary-500", "bg-foreground-700"];

export default function CommunityZone() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 pb-10 md:px-6">
        <div className="flex items-end justify-between gap-3 border-b border-background-200 pb-3">
          <div>
            <div className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-700">
              <i className="ri-community-line"></i>瓜友广场
            </div>
            <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">同一个瓜，一起蹲才够味</h2>
          </div>
          <a href="#feed" className="shrink-0 whitespace-nowrap text-sm text-foreground-600 hover:text-primary-700">
            去广场唠唠<i className="ri-arrow-right-line ml-1 text-xs"></i>
          </a>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {communityPosts.map((p, i) => (
            <a
              key={p.name}
              href="#feed"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 transition hover:border-primary-200 hover:bg-background-50"
            >
              <div className="flex items-center gap-2.5">
                <span className={"flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-background-50 " + toneBg[i % toneBg.length]}>
                  {p.avatar}
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-sm font-medium text-foreground-900">{p.name}</span>
                  <span className="block text-[11px] text-foreground-500">{p.role}</span>
                </span>
                <span className="ml-auto whitespace-nowrap text-[11px] text-foreground-400">{p.time}</span>
              </div>
              <p className="mt-3 flex-1 line-clamp-3 text-sm leading-relaxed text-foreground-700">{p.text}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-500 group-hover:text-primary-700">
                {p.hot && <i className="ri-fire-fill text-primary-600"></i>}
                进他的楼<i className="ri-arrow-right-line text-[11px]"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}